import { c as _c } from "react/compiler-runtime";
import s from "./Navbar.module.scss";
import Link from "next/link";
import MoreOptions from "@/assets/icons/MoreOptions";
import { useState } from "react";
type NavbarProps = {
  page: string;
};
export default function NavBar(t0) {
  const $ = _c(23);
  const {
    page
  } = t0;
  const [menuOpen, setMenuOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMenuOpen(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMenuClose = t1;
  let t2;
  if ($[1] !== menuOpen) {
    t2 = () => setMenuOpen(!menuOpen);
    $[1] = menuOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleMenuToggle = t2;
  const t3 = `${s.menuContent} ${menuOpen ? s.opened : ""}`;
  const t4 = `${s.link} ${page == "home" ? s.selected : ""}`;
  let t5;
  if ($[3] !== t4) {
    t5 = <Link href="/" className={t4} onClick={handleMenuClose}>Home</Link>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = `${s.link} ${page == "about-me" ? s.selected : ""}`;
  let t7;
  if ($[5] !== t6) {
    t7 = <Link href="/AboutMePage" className={t6} onClick={handleMenuClose}>About Me</Link>;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = `${s.link} ${page == "projects" ? s.selected : ""}`;
  let t9;
  if ($[7] !== t8) {
    t9 = <Link href="/ProjectsPage" className={t8} onClick={handleMenuClose}>Projects</Link>;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = `${s.link} ${page == "contacts" ? s.selected : ""}`;
  let t11;
  if ($[9] !== t10) {
    t11 = <Link href="/ContactsPage" className={t10} onClick={handleMenuClose}>Contacts</Link>;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t11 || $[12] !== t3 || $[13] !== t5 || $[14] !== t7 || $[15] !== t9) {
    t12 = <div className={t3}>{t5}{t7}{t9}{t11}</div>;
    $[11] = t11;
    $[12] = t3;
    $[13] = t5;
    $[14] = t7;
    $[15] = t9;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <MoreOptions />;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== handleMenuToggle) {
    t14 = <button className={s.menu} onClick={handleMenuToggle}>{t13}</button>;
    $[18] = handleMenuToggle;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t12 || $[21] !== t14) {
    t15 = <nav className={s.navContainer}>{t12}{t14}</nav>;
    $[20] = t12;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
}